// extracted by mini-css-extract-plugin
export default {"SettingsContainer":"styles_SettingsContainer__zU18j"};